module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sketch"
  }, [_c('div', {
    staticClass: "Box menu"
  }, [_c('Search'), _vm._v(" "), _c('List')], 1), _vm._v(" "), _c('Sidebar', {
    staticClass: "L order",
    attrs: {
      "itemX": ".menu",
      "itemY": ".workspace",
      "limit": "15%"
    }
  }), _vm._v(" "), _c('Palette', {
    staticClass: "Box workspace"
  }), _vm._v(" "), _c('Sidebar', {
    staticClass: "R order",
    attrs: {
      "itemX": ".workspace",
      "itemY": ".code",
      "limit": "8%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Box code"
  }, [_c('MenuBar'), _vm._v(" "), _c('CodeEditor')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-747fc05d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 101
// module chunks = 0